import TeamsRow from './Row'

export default TeamsRow
